import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import '../../../../styles/portalLayout.scss';

const PreviewWarningContextProvider = lazy(() => import('../../../../contexts/PreviewWarningContext/PreviewWarningContext'));
const HeaderComponent = lazy(() => import('../../../carePortalLayout/HeaderComponent/HeaderComponent'));
const BillerPortalSideMenuComponent = lazy(() => import('../BillerPortalSideMenuComponent/BillerPortalSideMenuComponent'));
const PreviewEnvWarningBannerComponent = lazy(() => import('../../../../uiComponent/PreviewEnvWarningComponent/PreviewEnvWarningBannerComponent'));
const ErrorBoundaryPageComponent = lazy(() => import('../../../../uiComponent/ErrorBoundaryComponent/ErrorBoundaryPageComponent'));
const ErrorBoundaryAppComponent = lazy(() => import('../../../../uiComponent/ErrorBoundaryComponent/ErrorBoundaryAppComponent'));

export const BillerPortalLayoutComponent = () => (
  <ErrorBoundaryAppComponent>
    <Suspense fallback={<Spin />}>
      <PreviewWarningContextProvider>
        <div className="biller-portal portal-layout">
          <div className="portal-header">
            <HeaderComponent isBillerPortal />
          </div>
          <PreviewEnvWarningBannerComponent />
          <div className="portal-body">
            <div className="portal-side-menu">
              <BillerPortalSideMenuComponent />
            </div>
            <div className="portal-content">
              <React.Suspense fallback="loading...">
                <ErrorBoundaryPageComponent page="BILLER_PORTAL_PAGE">
                  <Outlet />
                </ErrorBoundaryPageComponent>
              </React.Suspense>
            </div>
          </div>
        </div>
      </PreviewWarningContextProvider>
    </Suspense>
  </ErrorBoundaryAppComponent>
);
